import type { MaterialId } from '../content/materials';
import type { SourceYield } from './entities';

export function pickWeighted(
  yields: SourceYield[],
  random: () => number = Math.random,
): MaterialId {
  const total = yields.reduce((sum, y) => sum + y.weight, 0);
  let roll = random() * total;
  for (const y of yields) {
    roll -= y.weight;
    if (roll < 0) return y.material;
  }
  return yields[yields.length - 1].material;
}
